import { EnrolmentTypes } from '@/constants/use-case/enrolment';

export const getSystemList = (
  items,
  pitstopList,
  enrolmentType,
) => items.map((item)=>{

  if(enrolmentType.toUpperCase() === EnrolmentTypes.provider) {
    if(item.$selected && pitstopList?.length === 1 && !pitstopList?.some(pitstop => pitstop.id === item.id)){
      return {...item, $ccToContributor: true, contributorSystemId: pitstopList[0].id, contributorSystemName:pitstopList[0].name, $sysOptionsVisible: false}
    }

    if(item.$selected && !pitstopList?.some(pitstop => pitstop.id === item.id)){
      return {...item, $ccToContributor: true, contributorSystemId: undefined, contributorSystemName:"", $sysOptionsVisible: false}
    }
  }

  return item
});


export const isPitstopSelected = (
  selectedSystemItem,
  pitstopList,
) => selectedSystemItem.every(item =>{

  if (pitstopList?.length === 1){
    return true
  }

  if(item["$ccToContributor"] && item.contributorSystemId){
    return true
  }

  return !item["$ccToContributor"];
})

export const isSubmitBtnDisabled = (
  loading,
  enrolmentType,
  selectedSystemItem,
  pitstopList,
) => {
  return loading || (
    enrolmentType.toUpperCase() === EnrolmentTypes.provider
    && !isPitstopSelected(selectedSystemItem, pitstopList)
  )
}
